import { Button, Checkbox, Col, Divider, Form, Input, Result, Row, Select, message } from "antd";
import { DatePicker } from "antd/es";
import { useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { BsCheckCircle } from "react-icons/bs";
import { Link } from "react-router-dom";
import axios from "../../config/axios";
import FamilyCard from "../FamilyCard/FamilyCard";
import GoogleLoginButton from "../GoogleLoginButton/GoogleLoginButton";
import styles from "./AuthModal.module.scss";

const SPECIAL_CHARACTER = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;

const RegisterForm = ({ dfCard = false, onSuccess, onSwitchToSignIn, onClose }) => {
    const [loading, setLoading] = useState(false);
    // holds the address we mailed the confirmation link to, once registration went through
    const [registeredEmail, setRegisteredEmail] = useState(null);
    const [pass, setPass] = useState("");

    const addonBefore = (
        <div>
            <AiOutlineMail size={15} color={"var(--color-grey)"} />
        </div>
    );

    const registerNewUser = async (values) => {
        try {
            setLoading(true);
            values.df_card = dfCard ? true : null;

            await axios.post(`/users/register`, values);
            message.success("Registration successful!");
            setRegisteredEmail(values.email);
        } catch (error) {
            if (error.response?.status === 400) {
                message.error("An user with this email already exist. Please login or reset password.");
                return;
            }
            message.error("Something went wrong, try again!");
        } finally {
            setLoading(false);
        }
    };

    if (registeredEmail) {
        return (
            <div className={styles.auth_body}>
                <Result
                    status="success"
                    title="Please Verify Your Email!"
                    subTitle={`We have sent a confirmation email to ${registeredEmail} for verification. Please verify your email address to sign in.`}
                    extra={
                        <Button type="primary" size="large" onClick={onSwitchToSignIn}>
                            Go to Login
                        </Button>
                    }
                />
            </div>
        );
    }

    return (
        <div className={styles.auth_body}>
            <h2 className={styles.auth_heading}>Join for Exclusive Benefits!</h2>

            {dfCard && (
                <div className={styles.family_card_wrapper}>
                    <FamilyCard />
                </div>
            )}

            <h3 className={styles.auth_subheading}>Sign Up</h3>

            <div className={styles.scroll_body}>
                <div className={styles.social_row}>
                    <GoogleLoginButton dfCard={dfCard} onSuccess={onSuccess} text="signup_with" />
                </div>

                <Divider className="my-2">
                    <span className={styles.divider_label}>OR</span>
                </Divider>

                <Form
                    name="register"
                    initialValues={{ title: "Mr.", newsletter: false }}
                    onFinish={registerNewUser}
                    scrollToFirstError
                    layout="vertical"
                    requiredMark={false}
                    labelCol={{ style: { fontWeight: 500 } }}
                    className={styles.auth_form}
                >
                    <Row gutter={[20, 0]}>
                        <Col lg={12} xs={24}>
                            <Form.Item
                                name="first_name"
                                label="First Name"
                                rules={[{ required: true, message: "Please input your first name!" }]}
                            >
                                <Input
                                    addonBefore={
                                        <Form.Item name="title" noStyle>
                                            <Select style={{ width: 70 }}>
                                                <Select.Option value="Mr.">Mr.</Select.Option>
                                                <Select.Option value="Mrs.">Mrs.</Select.Option>
                                                <Select.Option value="Ms.">Ms.</Select.Option>
                                                <Select.Option value="Miss.">Miss</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    }
                                    size="large"
                                    placeholder="John"
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        </Col>

                        <Col lg={12} xs={24}>
                            <Form.Item
                                name="last_name"
                                label="Last Name"
                                rules={[{ required: true, message: "Please input your last name!" }]}
                            >
                                <Input size="large" placeholder="Doe" />
                            </Form.Item>
                        </Col>

                        <Col lg={24} xs={24}>
                            <Form.Item
                                name="email"
                                label={"E-mail"}
                                rules={[
                                    { type: "email", message: "The input is not valid Email!" },
                                    { required: true, message: "Please input your email address!" },
                                ]}
                            >
                                <Input size={"large"} type="email" addonBefore={addonBefore} />
                            </Form.Item>
                        </Col>

                        <Col lg={24} xs={24}>
                            <Form.Item name={"birthday"} label={"Celebrate your birthday with Desi Fresh"}>
                                <DatePicker size={"large"} style={{ width: "100%" }} placeholder={""} />
                            </Form.Item>
                        </Col>

                        <Col lg={24} xs={24}>
                            <Form.Item
                                name="password"
                                label="Password"
                                rules={[{ required: true, message: "Please input your password!" }]}
                                hasFeedback
                            >
                                <Input.Password
                                    size="large"
                                    placeholder="8+ Characters Required"
                                    onChange={(e) => setPass(e.target.value)}
                                />
                            </Form.Item>
                            <div className={styles.pass_check}>
                                <div>
                                    <BsCheckCircle
                                        color={pass.length > 7 ? "var(--color-primary)" : "var(--color-red)"}
                                        size={15}
                                    />
                                    <span>Use minimum 8 characters</span>
                                </div>
                                <div>
                                    <BsCheckCircle
                                        color={
                                            SPECIAL_CHARACTER.test(pass) ? "var(--color-primary)" : "var(--color-red)"
                                        }
                                        size={15}
                                    />
                                    <span>Once special character</span>
                                </div>
                                <div>
                                    <BsCheckCircle
                                        color={/[A-Z]/.test(pass) ? "var(--color-primary)" : "var(--color-red)"}
                                        size={15}
                                    />
                                    <span>uppercase letter</span>
                                </div>
                                <div>
                                    <BsCheckCircle
                                        color={/[a-z]/.test(pass) ? "var(--color-primary)" : "var(--color-red)"}
                                        size={15}
                                    />
                                    <span>lowercase letters</span>
                                </div>
                            </div>
                        </Col>

                        <Col lg={24} xs={24}>
                            <Form.Item name="newsletter" valuePropName="checked" className={"auth_check_override"}>
                                <Checkbox style={{ color: "var(--color-dark)" }}>
                                    Our Desi Fresh account terms and conditions apply, and we process your data in
                                    compliance with our{" "}
                                    <Link to={"/terms-and-condition"} className={styles.legal} onClick={onClose}>
                                        Privacy Policy
                                    </Link>
                                    .
                                </Checkbox>
                            </Form.Item>
                        </Col>

                        {dfCard && (
                            <Col lg={24} xs={24}>
                                <Form.Item
                                    name="df_newsletter"
                                    valuePropName="checked"
                                    className={"auth_check_override"}
                                >
                                    <Checkbox style={{ color: "var(--color-dark)" }}>
                                        Yes, I would like to recieve the offers and updates by e-mail and agree to the
                                        processing of my personal data in accordance with the Desi Family membership
                                        <Link to={"/data-protection"} className={styles.legal} onClick={onClose}>
                                            {" "}
                                            Data Protection Policy
                                        </Link>
                                        . You can unsubscribe anytime you wish to not recieve any information about
                                        products and promotions of Desi Fresh. For more information. please see our{" "}
                                        <Link to={"/data-protection"} className={styles.legal} onClick={onClose}>
                                            privacy policy
                                        </Link>
                                    </Checkbox>
                                </Form.Item>
                            </Col>
                        )}

                        <Col lg={24} xs={24}>
                            <Form.Item style={{ marginTop: 15, marginBottom: 8 }}>
                                <Button
                                    className={styles.submit_btn}
                                    size="large"
                                    type="primary"
                                    htmlType="submit"
                                    loading={loading}
                                    disabled={loading}
                                    block
                                >
                                    Sign Up Now
                                </Button>
                            </Form.Item>
                        </Col>

                        <Col lg={24} xs={24}>
                            <span className={styles.switch_line}>
                                Already a Member?{" "}
                                <button type="button" className={styles.switch_button} onClick={onSwitchToSignIn}>
                                    Log In Now
                                </button>
                            </span>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    );
};

export default RegisterForm;
